var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-content',{staticClass:"b_shopping_form content",attrs:{"id":_vm.value},on:{"send":_vm.onSend}})
}
var staticRenderFns = []

export { render, staticRenderFns }